import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromADM } from 'core/contexts/device-types';
import { SettingsDevicesPredefinedCommentsDashboardContainer } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-dashboard/settings-devices-predefined-comments-dashboard.container';

export const SettingsDevicesPredefinedCommentsScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromADM} source={DEVICE_TYPE_SOURCE.ADM}>
        <SettingsDevicesPredefinedCommentsDashboardContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesPredefinedCommentsScene;
